export default __webpack_public_path__ + "static/media/Tome of Holy Obeisance.94610c37.jpg";